function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 5h-2.333A4.665 4.665 0 0010 .333 4.665 4.665 0 005.333 5H3A2.34 2.34 0 00.667 7.333v14A2.34 2.34 0 003 23.667h14a2.34 2.34 0 002.333-2.334v-14A2.34 2.34 0 0017 5zm-7-2.333A2.34 2.34 0 0112.333 5H7.667A2.34 2.34 0 0110 2.667zm7 18.666H3v-14h2.333v2.334A1.17 1.17 0 006.5 10.833a1.17 1.17 0 001.167-1.166V7.333h4.666v2.334a1.17 1.17 0 001.167 1.166 1.17 1.17 0 001.167-1.166V7.333H17v14z"
});

function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgCart;